export class UnauthorizedError extends Error {
  constructor() {
    super('Unauthorized');
    this.name = 'UnauthorizedError';
  }
}

export class RequestFailedError extends Error {
  public readonly status: number;

  constructor(status: number) {
    super(`Request failed with status ${status}`);
    this.name = 'RequestFailedError';
    this.status = status;
  }
}

export class TimeoutError extends Error {
  public readonly timeoutMs: number;

  constructor(timeoutMs: number) {
    super(`Request timed out after ${timeoutMs}ms`);
    this.name = 'TimeoutError';
    this.timeoutMs = timeoutMs;
  }
}
